import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { OverlayService } from './services/overlay.service';
import { BrowserService } from './services/browser.service';
import { AuthService } from './services/auth.service';
import { GeolocationService } from './services/geolocation.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  @ViewChild('overlay', { static: true }) overlay: ElementRef;
  @ViewChild('overlayMessage', { static: true }) overlayMessage: ElementRef;

  public get isLogged(): boolean {
    return this.authService.isLogged$.getValue();
  }

  constructor(
    router: Router,
    private authService: AuthService,
    private overlayService: OverlayService,
    private browserService: BrowserService,
    public geolocationService: GeolocationService
  ) {
    router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        overlayService.showLoading('Veuillez patienter quelques instants ...');
      } else if (event instanceof RouteConfigLoadEnd) {
        overlayService.hideLoading();
      }
    });
  }

  ngOnInit() {
    this.overlayService.overlay = this.overlay;
    this.overlayService.overlayMessage = this.overlayMessage;
    this.geolocationService.getLocation();
  }

  onLogout() {
    this.authService.logout();
  }
}
